export enum HeaderConstants {
  CORRELATION_ID = 'x-lc-cid',
  APPNAME = 'x-lc-appName',
  PATHNAME = 'x-lc-app-path',
  PRODUCTNAME = 'x-lc-product-name',
}
